import React from 'react'

const ContactInfo = () => {
    return (
        <>
            <section className='contact-info-wrap'>
                <div className='container'>
                    <div className='row mlr-60'>
                        <div className='col-lg-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.2s">
                            <div className='main-title mb-4 font-3em'>Boerne</div>
                            <iframe className='ci-iframe' src="https://snazzymaps.com/embed/686106" width="100%" height="460px" ></iframe>
                            <div className='gt-info mt-5'>
                                <div className='gt-title mb-3'>Boerne, TX</div>
                                <div className='gt-address mb-3'>140 Enterprise Parkway Boerne, TX 78006</div>
                                <div className='gt-phone'><a href='tel:8309815050' className='text-white'>830-981-5050</a></div>
                            </div>
                        </div>
                        <div className='col-lg-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.2s">
                            <div className='main-title mb-4 font-3em'>Austin</div>
                            <iframe className='ci-iframe' src="https://snazzymaps.com/embed/686109" width="100%" height="460px" ></iframe>
                            <div className='gt-info mt-5'>
                                <div className='gt-title mb-3'>Austin, TX</div>
                                <div className='gt-address mb-3'>2301 Double Creek Dr #270, Round Rock, TX 78664</div>
                                <div className='gt-phone'><a href='tel:5122337800' className='text-white'>512-233-7800</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ContactInfo